import { useMemo, useState } from "react";
import { GitCommit, ShieldCheck } from "lucide-react";
import api from "../lib/api";

export default function BuildLincBaselineAdoption({ project, branches = [], onAdopted }) {
  const [sha, setSha] = useState("");
  const [branch, setBranch] = useState("");
  const [runtimeUrl, setRuntimeUrl] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const branchNames = useMemo(() => branches.map((item) => item.name).filter(Boolean), [branches]);

  const adopt = async () => {
    const cleanSha = sha.trim();
    if (!project?.id || !/^[0-9a-fA-F]{7,40}$/.test(cleanSha)) return;
    if (!window.confirm("Adopt this exact GitHub commit as the existing deployed baseline? Only continue if this revision is known to be the runtime you are actually using.")) return;
    setSaving(true);
    setError("");
    try {
      await api.post(`/projects/${project.id}/buildlinc/deployment`, {
        sha: cleanSha,
        branch: branch || null,
        preview_url: runtimeUrl.trim() || null,
        note: "Existing external deployment adopted into BuildLinc baseline",
      });
      setSha("");
      setRuntimeUrl("");
      if (onAdopted) await onAdopted();
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : detail?.message || "BuildLinc could not adopt that deployment baseline.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <article className="buildlinc-panel" style={{ marginBottom: 10 }} data-testid="buildlinc-baseline-adoption">
      <header>
        <div><GitCommit size={16} /><span><b>Adopt existing deployment</b><small>Bootstrap a project into BuildLinc before candidate comparisons begin.</small></span></div>
      </header>
      <div className="buildlinc-form-grid">
        <label><small>Exact deployed GitHub SHA</small><input value={sha} onChange={(e) => setSha(e.target.value)} placeholder="40-character commit SHA" /></label>
        <label><small>Known source branch</small><select value={branch} onChange={(e) => setBranch(e.target.value)}><option value="">Unknown / not recorded</option>{branchNames.map((name) => <option key={name} value={name}>{name}</option>)}</select></label>
        <label><small>Runtime / preview URL</small><input value={runtimeUrl} onChange={(e) => setRuntimeUrl(e.target.value)} placeholder="Optional https://..." /></label>
        <div className="buildlinc-readonly"><b>Human-confirmed baseline</b><span>BuildLinc verifies the SHA exists in the configured GitHub repository, then stores it in the append-only audit ledger.</span></div>
      </div>
      {error ? <p className="buildlinc-hint" style={{ color: "var(--red)" }}>{error}</p> : null}
      <button className="btn primary" style={{ margin: "0 13px 12px" }} disabled={saving || !/^[0-9a-fA-F]{7,40}$/.test(sha.trim())} onClick={adopt}>{saving ? "Verifying…" : "Adopt existing baseline"}</button>
      <div className="buildlinc-scope-note"><ShieldCheck size={14} /><span><b>Why this is explicit</b><small>Branch tips can move without a deployment. BuildLinc records the exact runtime revision rather than assuming the newest commit is live.</small></span></div>
    </article>
  );
}
